import { useEffect, useState } from 'react';
import { Alert, Button, Col, Form, Row, Spinner } from 'react-bootstrap';
import { getPlatformSettings, updatePlatformSettings } from '../api';

// v3_fix_issues #10 - the website owner sets who gets notified when a prospect requests a demo:
// the platform owner and the appointed marketing-team manager (email + WhatsApp). Admin only.
const FIELDS = [
  ['websiteOwnerEmail', 'Website owner email', 'email'],
  ['websiteOwnerWhatsapp', 'Website owner WhatsApp', 'text'],
  ['marketingManagerEmail', 'Marketing manager email', 'email'],
  ['marketingManagerWhatsapp', 'Marketing manager WhatsApp', 'text']
];

export default function PlatformSettingsPanel() {
  const [settings, setSettings] = useState(null);
  const [msg, setMsg] = useState('');
  const [error, setError] = useState('');

  useEffect(() => {
    getPlatformSettings().then(setSettings).catch(() => setError('Could not load platform settings.'));
  }, []);

  const save = async (e) => {
    e.preventDefault();
    setMsg('');
    setError('');
    try {
      const payload = Object.fromEntries(FIELDS.map(([k]) => [k, settings[k] || '']));
      setSettings(await updatePlatformSettings(payload));
      setMsg('Saved.');
    } catch (err) {
      setError(err.response?.data?.msg || 'Unable to save.');
    }
  };

  if (error && !settings) return <Alert variant="danger">{error}</Alert>;
  if (!settings) return <Spinner animation="border" size="sm" role="status" />;

  return (
    <Form onSubmit={save} style={{ maxWidth: 520 }}>
      <p className="text-muted small">
        Demo requests from the footer and the homepage contact form are emailed and WhatsApp'd to
        these contacts.
      </p>
      {msg && <Alert variant="success" className="py-2">{msg}</Alert>}
      {error && <Alert variant="danger" className="py-2">{error}</Alert>}
      <Row className="g-2">
        {FIELDS.map(([key, label, type]) => (
          <Col xs={12} md={6} key={key}>
            <Form.Group className="mb-2">
              <Form.Label className="small mb-0">{label}</Form.Label>
              <Form.Control
                size="sm" type={type} aria-label={label}
                value={settings[key] || ''}
                onChange={(e) => setSettings((s) => ({ ...s, [key]: e.target.value }))}
              />
            </Form.Group>
          </Col>
        ))}
      </Row>
      <Button size="sm" type="submit">Save settings</Button>
    </Form>
  );
}
